<template>
  <base-page-template :fit="fit">
    <template #toolbar-items>
      <slot name="toolbar-items"></slot>
    </template>
    <template #default>
      <slot></slot>

      <template v-if="hasLeftOfTabs || hasRightOfTabs">
        <multipane class="tab-container" @pane-resizing="$emit('pane-resizing')" :style="bottomContainerStyle">
          <slot
              v-if="hasLeftOfTabs"
              name="left-tabs">
          </slot>
          <multipane-resizer
              v-if="hasLeftOfTabs && (hasTabItems || hasRightOfTabs)">
          </multipane-resizer>
          <v-tabs v-model="tabView" center-active background-color="primary" dark ref="vtab-bar" v-if="hasTabItems">
            <slot name="tab-items"></slot>
          </v-tabs>
          <slot name="after-tabs"></slot>
          <multipane-resizer
              v-if="hasRightOfTabs && hasTabItems">
          </multipane-resizer>
          <slot
              v-if="hasRightOfTabs"
              name="right-tabs">
          </slot>
        </multipane>
      </template>
      <template v-else>
        <div class="tab-container" :style="bottomContainerStyle">
          <v-tabs v-model="tabView" center-active background-color="primary" dark ref="vtab-bar" v-if="hasTabItems">
            <slot name="tab-items"></slot>
          </v-tabs>
          <slot name="after-tabs"></slot>
        </div>
      </template>
    </template>
  </base-page-template>
</template>

<script>
import BasePageTemplate from "@/components/templates/BasePageTemplate.vue";
import Multipane from "@/components/atoms/Multipane.vue";
import MultipaneResizer from "@/components/atoms/MultipaneResizer.vue";
import {isString} from "@/utils/TypeUtil";

export default {
  name: "TabPageTemplate",
  components: {
    BasePageTemplate,
    Multipane,
    MultipaneResizer,
  },
  inject: [
    'mainPadding',
    'mainBounds',
    'mainScroll',
    'appHeader',
  ],
  provide() {
    return {
      tabItemBounds: this.tabItemBoundsImpl
    };
  },
  props: {
    tab: {
      required: false,
    },
    fit: {
      type: Boolean,
      default: false
    },
    maximizable: {
      type: Boolean,
      default: false
    },
  },
  model: {
    prop: 'tab',
    event: 'tab-change'
  },
  data() {
    return {
      tabView: 0,
      tabItemBoundsImpl: {
        height: 0
      }
    };
  },
  computed: {
    hasTabItems() {
      return !!this.$slots['tab-items']?.length;
    },
    hasLeftOfTabs() {
      return !!this.$slots['left-tabs']?.length;
    },
    hasRightOfTabs() {
      return !!this.$slots['right-tabs']?.length;
    },
    bottomContainerStyle() {
      if(this.maximizable || this.fit) {
        const {mainPadding: padding, mainBounds: bounds, appHeader} = this;
        return {
          height: `calc(${bounds.height} - ${padding.top} - ${padding.bottom} - ${appHeader.height} - 3px)`
        };
      } else {
        return {};
      }
    },
    tabItemBounds() {
      if(this.maximizable || this.fit) {
        const {mainPadding: padding, mainBounds: bounds, appHeader} = this;
        return {
          // 3px: 謎
          // 98px: Tab バーの高さ + Secondary ツールバーの高さ
          height: `calc(${bounds.height} - ${padding.top} - ${padding.bottom} - ${appHeader.height} - 3px - 96px)`
        };
      } else {
        return {};
      }
    }
  },
  watch: {
    'mainScroll.y': {
      handler() {
        const {mainScroll: scroll} = this;
        const {y, height, moveTo} = scroll;
        if(height - 32 < y) {
          moveTo({top: height, behavior: 'instant'});
        }
      }
    },
    'tabItemBounds': {
      immediate: true,
      handler(tabItemBounds) {
        this.tabItemBoundsImpl.height = tabItemBounds.height;
      }
    },
    tabView: {
      immediate: true,
      handler(newValue, oldValue) {
        if(newValue === oldValue) {
          return;
        }

        this.tabView = newValue;
        this.$emit('tab-change', newValue);

        if(isString(newValue)) {
          this.$store.dispatch('hcs/fetchLoginAccount').then(() => {
            const {route: tabRoute} = this.$router.resolve(newValue);
            const curRoute = this.$route;
            if (curRoute.name !== tabRoute.name) {
              this.$router.replace({
                ...tabRoute,
                query: curRoute.query,
                params: curRoute.params,
              });
            }
          });
        }
      }
    },
    '$route': {
      handler() {
        if(isString(this.tabView)) {
          this.$store.dispatch('hcs/fetchLoginAccount').then(() => {
            const {route: tabRoute} = this.$router.resolve(this.tabView);
            const curRoute = this.$route;
            if (curRoute.name !== tabRoute.name) {
              this.$router.replace({
                ...tabRoute,
                query: curRoute.query,
                params: curRoute.params,
              });
            }
          });
        }
      }
    }
  }
}
</script>

<style scoped>
.multipane.layout-v {
  flex-grow: 1;
}
</style>
